import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "@tanstack/react-router";

// Self-hosted Inter. Deliberately not the Google Fonts CDN: that would disclose
// every user's IP and page load to a third party and force script/style/font-src
// to allow an external origin.
import "@fontsource-variable/inter";
import "./styles.css";

import { getRouter } from "./router";

const router = getRouter();

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error('Root element "#root" not found');

createRoot(rootElement).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
